/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import { colorsMap } from './constants';

const Styles = {
  root: key => css`
    background-color: rgba(${colorsMap[key]});
    display: inline-block;
    width: 10px;
    height: 10px;
    content: '';
  `,
};

type Props = {
  colorKey: string;
};

function ColorSquare({ colorKey }: Props) {
  return <span css={Styles.root(colorKey)} title={colorKey}></span>;
}

export default ColorSquare;
